import { styled } from '@mui/material';
import { ArrowUpIcon } from './icons';
import type { IconProps } from './icons';

export type UpDownArrowIconProps = IconProps & {
    direction: 'up' | 'down' | 'none';
};
const SmallArrowUpIcon = ({ size = 14, ...props }: IconProps) => (
    <ArrowUpIcon size={size} {...props} />
);
export const UpDownArrowIcon = styled(SmallArrowUpIcon, {
    shouldForwardProp: (propName) => propName !== 'direction',
    skipSx: false,
})<UpDownArrowIconProps>(({ direction }) => ({
    transition: 'transform 0.25s',
    transform: `scaleY(${
        direction === 'up' ? 1 : direction === 'down' ? -1 : 0
    })`,
}));
